import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER,  persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { thunk } from 'redux-thunk';

import authSlice from './slices/authSlice';
import projectSlice from './slices/projectSlice';
import contentSlice from './slices/contentSlice';
import triggerSlice from './slices/triggerSlice';

const persistConfig = {
	key: 'root',
	storage,
	blacklist: ['content']
};

const rootReducer = combineReducers({
	auth: authSlice.reducer,
	project: projectSlice.reducer,
	content: contentSlice.reducer,
	trigger: triggerSlice.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
	reducer: persistedReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: {
				ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER, 'trigger/triggerAPI'],
				ignoredPaths: ['trigger.showPublicDetail'],
			},
		}).concat(thunk),
});

export default store;
export const persistor = persistStore(store);
